module.exports = "<symbol id=\"tt-icon-controls\" viewBox=\"0 0 24 24\"><path d=\"M.17 5.85v2.39h3.92a3.77 3.77 0 0 0 3.7 2.68 3.79 3.79 0 0 0 3.71-2.68h12.33V5.85H11.52a4.11 4.11 0 0 0-3.73-2.72 4.13 4.13 0 0 0-3.73 2.72zM19.91 14.93a4.11 4.11 0 0 0-3.73-2.72 4.13 4.13 0 0 0-3.73 2.72H.17v2.39h12.31a3.76 3.76 0 0 0 3.7 2.68 3.78 3.78 0 0 0 3.71-2.68h3.94v-2.39z\" xmlns=\"http://www.w3.org/2000/svg\"/></symbol>"


//////////////////
// WEBPACK FOOTER
// ./src/build/v6J5ZUpvDmQ7AMLsite/assets/svg/comments-pinboard-page/controls.svg
// module id = 185
// module chunks = 11